import {
  FunctionComponent,
  createContext,
  useContext,
  useReducer,
} from "react";
import { UserAction } from "../interfaces/Polling";
import { UserReducer, userInitialState } from "./UserReducer";
import { User } from "../generated/graphql";
const ContextState = createContext([]);

interface IDispatchParams {
  type: UserAction;
  payload: User;
}

const useApp = () => {
  const context = useContext(ContextState);
  if (!context) {
    throw new Error(`useApp must be used within a AppProvider`);
  }
  return context as unknown as [User, ({ ...args }: IDispatchParams) => void];
};

const AppProvider: FunctionComponent<any> = (props) => {
  const [state, dispatch] = useReducer(UserReducer, userInitialState);
  return (
    <ContextState.Provider
      value={
        [state, dispatch] as unknown as [
          User,
          ({ ...args }: IDispatchParams) => void
        ]
      }
      {...props}
    />
  );
};

export { useApp, AppProvider };

// export const AppProvider = (FunctionComponent<any> = (props) => {
//   const [user, setUser] = useState<IUserContext["user"]>(null);
//   const value = useMemo(() => ({ user, setUser }), [user]);

//   return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
// });
